import React from 'react';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
export default function withPress(WrappedComponent, options = {}) {
    const WithPress = ({ onPress, to, pressableProps, pressableStyle, disabled, ...rest }, ref) => {
        if ((onPress || to) && !disabled) {
            const { style, ...otherProps } = pressableProps || {};
            const { touchFeedback = true } = options;
            return (React.createElement(Pressable, { touchFeedback: touchFeedback, onPress: onPress, to: to, disabled: disabled, style: [pressableStyle, style], ...otherProps },
                React.createElement(WrappedComponent, { ref: ref, disabled: disabled, ...rest })));
        }
        return React.createElement(WrappedComponent, { ref: ref, disabled: disabled, ...rest });
    };
    WithPress.displayName = `withPress(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return React.forwardRef(WithPress);
}
